<template>
  <div v-if="item" class="mt-2 mb-2 d-flex flex-row align-content-center justify-content-between">
    <mdb-icon
      :icon="icon"
      :title="tooltip"
      color="default"
      class="mr-3"/>
    <bridge8-popover
      :obj="entity"
      :fields="true"
      :header-prefix="`${tooltip}: `"
      trigger="hover"
      :text-callback="textCallback"
    />
    <a
      @click="$emit('remove-item', index)"
      title="Remove item from cart"
      class="ml-3"
    >
      <mdb-icon icon="times" color="danger"/>
    </a>
  </div>
</template>

<script>
import {mdbIcon, mdbBtn} from 'mdbvue'
import Bridge8Popover from './Bridge8Popover'
import {EntityTypes} from '../enums'
import {capitalize, formatDT} from '../utils'

export default {
  name: 'AdminTabCartItem',
  props: {
    index: {
      type: Number,
      required: true
    },
    item: {
      type: Object,
      validator: function (item) {
        return Object.values(EntityTypes).includes(item.type) &&
          typeof item.entity === 'object'
      },
      required: true
    }
  },
  computed: {
    entity: {
      get: function () {
        return this.item && this.item.entity
      }
    },
    icon: {
      get: function () {
        switch (this.item.type) {
          case EntityTypes.NODE:
            return 'dot-circle'
          case EntityTypes.RELATIONSHIP:
            return 'exchange-alt'
        }
      }
    },
    tooltip: {
      get: function () {
        return capitalize(this.item.type)
      }
    }
  },
  methods: {
    textCallback: function (entity) {
      return entity.name || (entity.created && formatDT(entity.created)) || '--- n/a ---'
    }
  },
  components: {
    mdbIcon,
    mdbBtn,
    Bridge8Popover
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AdminTabCartItem.vue